<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0" :isMType="isMType" stepTitle="套餐及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <!-- -->
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品标题" prop="proName">
              <a-input v-model="ruleForm.proName" :maxLength="120" placeholder="商品标题组成：商品描述+规格">
                <span slot="addonAfter">{{ ruleForm.proName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="介绍标语" prop="proTitle">
              <a-textarea v-model="ruleForm.proTitle" :maxLength="200" placeholder="请输入"
                          :auto-size="{ minRows: 3, maxRows: 5 }"/>
            </a-form-model-item>
            <a-form-model-item label="类目属性" prop="commodityType">
              <a-select v-model="ruleForm.commodityType" allowClear placeholder="请选择" style="max-width:400px;">
                <a-select-option v-for="item in propertyList" :key="item.code" :value="item.code">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="商品品牌">
              <a-button @click="dialogVisible = true" style="margin-right:10px;">关联品牌</a-button>
              <a-tag v-if="ruleForm.commodityBrandId" closable @close="handleClose">{{ ruleForm.commodityBrandName }}
              </a-tag>
            </a-form-model-item>
            <a-form-model-item label="商品轮播图" prop="imgs">
              <custom-upload-pro-images v-model="ruleForm.imgs"
                                        :pro-id="proId" :multiple-selected="true"
                                        :draggableUpdate="true">
              </custom-upload-pro-images>
            </a-form-model-item>
            <a-form-model-item label="限时售卖">
              <a-range-picker name="buildTime"
                              v-model="limitedTime"
                              :disabledDate="disabledDate"
                              @change="onDateChange" show-time
                              format="YYYY-MM-DD HH:mm:ss"/>
            </a-form-model-item>
            <a-form-model-item label="图文详情" required>
              <CustomUeditor v-model="ruleForm.proDes"></CustomUeditor>
            </a-form-model-item>
            <a-form-model-item label="购买须知" prop="commodityNotice">
              <a-textarea v-model="ruleForm.commodityNotice" :maxLength="500" placeholder="请输入"
                          :auto-size="{ minRows: 5, maxRows: 10 }"/>
            </a-form-model-item>
            <a-form-model-item label="运费模板" prop="proFreightId">
              <a-select v-model="ruleForm.proFreightId" allowClear placeholder="请选择" style="max-width:400px;"
                        @dropdownVisibleChange="onDropdownChange">
                <a-select-option v-for="item in proFreightList" :key="item.templateId" :value="item.templateId">
                  {{ item.templateName }}
                </a-select-option>
              </a-select>
              <a @click="goProFreight">&nbsp;&nbsp;&nbsp;新建运费模板</a>
            </a-form-model-item>
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" :proId="proId" :catalogId="catalogId"
                             v-model="ruleForm.invoiceTemplateId"></InvoiceSelect>
            </a-form-model-item>
            <a-form-model-item label="商品备注" prop="remark">
              <a-input v-model="ruleForm.remark" style="width:800px" :maxLength="20" placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="跨境商品">
              <a-radio-group name="radioGroup" :disabled="!isCloseMerchandise || Number(proId) > 0"
                             v-model="ruleForm.crossBorderDirect">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="税费" prop="expenses" v-if="ruleForm.crossBorderDirect == 1">
              <a-input-number style="width:400px" v-model="ruleForm.expenses" :min="0" :max="100" :step="1"
                              :precision="2" placeholder="请输入"/>
              %
            </a-form-model-item>
            <a-form-model-item label="货主名称" prop="shipperSessionkey" v-if="ruleForm.crossBorderDirect == 1">
              <div v-if="proSource==1">{{ ruleForm.shipperName }}</div>
              <a-select v-else v-model="ruleForm.shipperSessionkey" allowClear placeholder="请选择货主名称"
                        style="max-width:400px;">
                <a-select-option v-for="item in merchantCrossBorderData" :key="item.id" :value="item.id">
                  {{ item.shipperName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button :disabled="proSource!=0" type="primary" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>
      </div>
    </div>
    <a-modal title="关联品牌" :width="600" :footer="null" :visible="dialogVisible" @cancel="handleCancel">
      <a-button @click="addOrChangeBrand(0,0)" style="margin-bottom:10px;">新增品牌</a-button>
      <custom-page-table
        :queryParams="queryParams"
        ref="table"
        rowKey="code"
        :columns="columns"
        request-type="get"
        base-key="proUrl"
        query-path="product/commodity/findProCommodityBrandList"
      >
        <span slot="action" slot-scope="rowItem">
          <a @click="selectBrand(rowItem.record)">选择</a>
          <a-divider type="vertical"></a-divider>
          <a @click="addOrChangeBrand(rowItem.record.code,rowItem.record)">修改</a>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm title="此操作将删除此品牌, 是否继续?" @confirm="deleteBrand(rowItem.record.code)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </custom-page-table>
    </a-modal>
    <a-modal title="新增品牌" :visible="popupVisible" width="550px" :footer="null" @cancel="handleAddCancel">
      <a-form-model :model="dataForm" ref="dataForm" :rules="dataRules"
                    :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="品牌名称" prop="commodityName">
          <a-input v-model="dataForm.commodityName" placeholder="请输入品牌名称" :maxLength="20"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">提交并下一步</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import InvoiceSelect from '../components/InvoiceSelect'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import userHelper from '@/utils/helper/userHelper'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import moment from 'moment'

export default {
  name: 'DepartmentBasicInfo',
  components: {
    ProductHeader,
    PublishHelper,
    CustomUeditor,
    InvoiceSelect,
    CustomUploadProImages
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      moment,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      queryParams: {},
      limitedTime: undefined,
      ruleForm: {
        proId: this.$route.query.proId,// 产品ID
        commodityBrandId: 0,// 百货品牌ID
        commodityBrandName: '',
        commodityEndTime: '',// 结束售卖时
        commodityNotice: '',// 购买须知
        commodityStartTime: '',// 开始售卖时间
        commodityType: undefined,// 百货属性
        imgs: [],// 产品图片
        proDes: '',// 产品详情
        proName: '',// 产品名称
        proTitle: '',// 产品标题
        proFreightId: undefined,//运费
        invoiceTemplateId: undefined,//发票
        crossBorderDirect: 0,
        expenses: '',
        shipperSessionkey: undefined
      },
      rules: {
        proName: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        proTitle: [
          { required: true, message: '请输入介绍标语', trigger: 'blur' }
        ],
        commodityType: [
          { required: true, message: '请选择类目属性', trigger: 'change' }
        ],
        imgs: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ],
        commodityNotice: [
          { required: true, message: '请输入购买须知', trigger: 'blur' }
        ],
        invoiceTemplateId: [
          { required: true, message: '请选择发票模板', trigger: 'change' }
        ],
        proFreightId: [
          { required: true, message: '请选择运费模板', trigger: 'change' }
        ],
        expenses: [
          { required: true, message: '请输入税费', trigger: 'blur' }
        ],
        shipperSessionkey: [
          { required: true, message: '请选择货主名称', trigger: 'blur' }
        ]
      },
      propertyList: [],
      dialogVisible: false,
      submitLoading: false,
      popupVisible: false,
      columns: [
        {
          title: '品牌ID',
          dataIndex: 'code'
        },
        {
          title: '品牌名称',
          dataIndex: 'name'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      dataForm: {
        commodityBrandId: 0,//百货品牌ID ,
        commodityName: '',//百货品牌名称
        removeCommodityBrand: false//是否删除百货品牌 ，true就是删除
      },
      dataRules: {
        commodityName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      },
      invoiceTemplateList: [],
      proFreightList: [],
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      isCloseMerchandise: false,
      merchantCrossBorderData: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getKeyValueList()
      this.getGoodsType()
      this.getProCommodityInfo()
    })
    this.getCloseMerchandise()
    this.getMerchantCrossBorderData()
  },
  computed: {
    isMType() {
      if (this.ruleForm.crossBorderDirect == 1 && this.isCloseMerchandise) {
        return 1
      } else {
        return 0
      }
    }
  },
  methods: {
    getCloseMerchandise() { //查询运营商是否开通跨境设置
      this.getHttpServices().getUserService().post('user/merchantInfo/queryMerchantCrossBorderDirectOpen', {
        merchantId: this.$store.getters.userInfo.merchantId
      }).then(res => {
        this.isCloseMerchandise = res.crossBorderDirect == 1 ? true : false
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getMerchantCrossBorderData() {
      this.getHttpServices().getUserService().post('user/merchantInfo/queryMerchantCrossBorderDirectShipperSessionkey', {
        merchantId: this.$store.getters.userInfo.merchantId
      }).then(res => {
        if (res && res.length) {
          this.merchantCrossBorderData = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取云仓token
    onDropdownChange() {
      this.getKeyValueList()
    },
    // 获取运费模板
    getKeyValueList() {
      let merchantId = this.$store.getters.userInfo.merchantId
      let platformId = this.getPlatformConfig().platformId
      this.getHttpServices().getCloudProService().get('base/express/fee/keyValueList?merchantId=' + merchantId + '&platformId=' + platformId).then(res => {
        this.getLogUtils().logWithTag('getGoodsType', res)
        this.proFreightList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //领取日期
    onDateChange(dates, dateStrArr) {
      // this.getLogUtils().logWithTag("onDateChange",dates);
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.limitedTime = dates
      this.ruleForm.commodityStartTime = dateStrArr[0]
      this.ruleForm.commodityEndTime = dateStrArr[1]
    },
    handleAddCancel() {
      this.popupVisible = false
    },
    handleCancel() {
      this.dialogVisible = false
    },
    // 获取商品类目属性
    getGoodsType() {
      this.getHttpServices().getBaseService().get('base/sysCode/getProCommodityType').then(res => {
        this.getLogUtils().logWithTag('getGoodsType', res)
        this.propertyList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    checkForm() {
      if (!this.ruleForm.proDes) {
        this.$message.error('请输入图文详情')
        return false
      }
      return true
    },
    //删除品牌
    handleClose() {
      this.ruleForm.commodityBrandId = 0
      this.ruleForm.commodityBrandName = ''
    },
    //选中品牌
    selectBrand(obj) {
      this.ruleForm.commodityBrandId = obj.code
      this.ruleForm.commodityBrandName = obj.name
      this.dialogVisible = false
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.imgs = this.submitFormData.imgs.length > 0 ? this.submitFormData.imgs.join(',') : ''
      delete this.submitFormData.commodityBrandName
      this.getHttpServices().getProService().post('product/commodity/editProCommodityInfo', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.ruleForm.proId = res
        this.$message.success('基本信息保存成功')
        this.$router.push({
          name: 'DepartmentPriceSetting',
          query: {
            proId: this.ruleForm.proId,
            catalogId: this.catalogId,
            proSource: this.proSource,
            isBack: this.proId == 0 ? 1 : undefined,
            isMType: this.isMType
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //新增或修改品牌
    addOrChangeBrand(code, item) {
      this.popupVisible = true
      if (code != 0) {
        this.dataForm.commodityBrandId = code//百货品牌ID ,
        this.dataForm.commodityName = item.name//百货品牌名称
        this.dataForm.removeCommodityBrand = false//是否删除百货品牌 ，true就是删除
      } else {
        this.dataForm.commodityBrandId = 0//百货品牌ID ,
        this.dataForm.commodityName = ''//百货品牌名称
        this.dataForm.removeCommodityBrand = false//是否删除百货品牌 ，true就是删除
      }
    },
    // 保存品牌
    handleSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.submitLoading = false
          this.getHttpServices().getProService().post('product/commodity/editProCommodityBrand', this.dataForm).then(res => {
            this.getLogUtils().logWithTag('submitData', res)
            this.$message.success('品牌保存成功')
            this.popupVisible = false
            this.$refs.table.refresh(true)
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 删除品牌
    deleteBrand(code) {
      this.getHttpServices().getProService().post('product/commodity/editProCommodityBrand', {
        commodityBrandId: code,
        removeCommodityBrand: true
      }).then(res => {
        this.getLogUtils().logWithTag('overbtn', res)
        this.$message.success('删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 查询基本信息接口
    getProCommodityInfo() {
      if (this.proId != 0) {
        this.getHttpServices().getProService().get('product/commodity/findProCommodityInfo?proId=' + this.proId).then(res => {
          this.getLogUtils().logWithTag('getProCommodityInfo', res)
          res.shipperSessionkey = res.shipperSessionkey ? res.shipperSessionkey : undefined
          this.ruleForm = res
          this.ruleForm.imgs = res.imgs && res.imgs != '' ? res.imgs.split(',') : []
          if (res.commodityEndTime && res.commodityEndTime != '') {
            this.limitedTime = this.getDateHelper().getDateMoments(res.commodityStartTime, res.commodityEndTime)
          }
          // this.getLogUtils().logWithTag("getProCommodityInfo",this.$refs.InvoiceSelect)
          this.$refs.InvoiceSelect.getMatchTemplateId()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    goProFreight() {
      let Logistics = this.$router.resolve({
        name: 'ConsolidationServices'
      })
      window.open(Logistics.href, '_blank')
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      flex-grow: 1;
      width: 400px;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>